<template>
  <div>
    <v-layout wrap>
      <v-flex lg2 md2 sm2 xs2>
        <div style="margin: 10px 0px 0px 10px;" @mouseleave="focusItem=null">
          <v-toolbar flat dark color="info" @mouseover="focusItem=null">
            <v-toolbar-title class="flex" style="text-align: center;">
              <label style="cursor: pointer;" @click="onSelectArea()">Tất cả khu</label>
            </v-toolbar-title>
          </v-toolbar>
          <table class="lstTable">
            <template v-for="(item, index) in lstArea">
              <tr :key="index">
                <td v-if="activeArea == item.categoryId"
                    style="text-align: center;padding: 10px;background-color: #ddd;">
                  <label style="cursor: pointer;"><strong>{{ item.categoryName }}</strong></label>
                </td>
                <td v-else style="text-align: center;padding: 10px;">
                  <label style="cursor: pointer;"
                         @click="onSelectArea(item.categoryId)"><strong>{{ item.categoryName }}</strong></label>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </v-flex>
      <v-flex lg10 md10 sm10 xs10>
        <v-tabs
            v-model="active_tab"
            slider-color="white"
            style="padding: 10px"
        >
          <v-tabs-slider color="#2196F3"></v-tabs-slider>
          <v-tab v-for="tab of tabs" :key="tab.id" @click="selectTab(tab.id)">
            {{ tab.name }}
          </v-tab>
        </v-tabs>
        
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="getFormName"
            :buttons="buttons"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="export_id"
            :search-url="searchUrl"
            create-url="/exportRequest/save"
            delete-url="/exportRequest/delete"
            form-type="intable"
            @createNew="openCreateDialog"
            :customCreateNew="true"
            ref="tableData"
            :deleteMulti="false"
            :acceptView="true"
            :acceptEdit="false"
            :acceptDelete="false"
            :acceptCreate="showCreate"
            :reload="reload"
            @viewItem="viewItem"
            @onConfirmDialog="onConfirmDialog"
            @openApproveDialog="openApproveDialog"
            @setLastSearchValues="setLastSearchValues"
            :lastSearchValues="lastSearchValues"
            @formSelectChange="formSelectChange"
        >
        </c-search-form>
      </v-flex>
    </v-layout>

    <v-dialog max-width="400px" v-model="approveDialog" persistent>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title style="padding-left: 0px">
            Chọn khu nuôi
          </v-toolbar-title>
        </v-toolbar>
        <v-btn
            @click="closeApproveDialog"
            icon
            style="
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        color: #fff;
                    "
        >
          <v-icon>cancel</v-icon>
        </v-btn>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                  :items="lstArea"
                  label="Khu nuôi"
                  v-model="areaId"
                  item-value="categoryId"
                  item-text="categoryName"
              />
            </v-flex>
            <v-flex xs12>
              <i-datepicker
                  :label="$t('lang.exportRequest.requestDate')"
                  v-model="requestDate"
                  v-validate="'required'"
                  name="requestDate"
                  :data-vv-as="$t('lang.exportRequest.requestDate')"
                  :error-messages="errors.first('requestDate')"
              />
            </v-flex>
            <v-flex xs12 v-if="active_tab === 0">
              <v-autocomplete
                  :items="lstMaterialTypeAlly"
                  label="Nhóm của nhóm vật tư"
                  v-model="materialTypeAllyId"
                  item-value="categoryId"
                  item-text="categoryName"
                  clearable
              />
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="requestStatusSummaryList"
                  label="Trạng thái"
                  v-model="requestStatusSummary"
                  item-value="value"
                  item-text="text"
              />
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="onApprove" v-if="roleBgd">
            <v-icon dark left>save</v-icon>
            {{ $t("Xem tổng hợp đề nghị xuất kho") }}
          </v-btn>
          <v-btn color="primary" @click="onConfirm" v-if="roleChiefEngineer">
            <v-icon dark left>save</v-icon>
            {{ $t("Xem tổng hợp đề nghị xuất kho") }}
          </v-btn>
          <v-btn color="primary" @click="onConfirm" v-if="roleWh">
            <v-icon dark left>save</v-icon>
            {{ $t("Xem tổng hợp đề nghị xuất kho") }}
          </v-btn>
          <v-btn color="error" @click="closeApproveDialog">
            <v-icon dark left>cancel</v-icon>
            {{ $t("lang.common.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="400px" v-model="dialog" persistent>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title style="padding-left: 0px">
            Chọn vụ nuôi
          </v-toolbar-title>
        </v-toolbar>
        <v-btn
            @click="close"
            icon
            style="
                        position: absolute;
                        right: 10px;
                        top: 10px;
                        color: #fff;
                    "
        >
          <v-icon>cancel</v-icon>
        </v-btn>
        <v-form
          ref="formCreateRequest"
          v-model="validFormCreateRequest"
          lazy-validation
        >
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-autocomplete
                  :items="lstArea"
                  label="Khu nuôi"
                  v-model="areaId"
                  name="areaId"
                  item-value="categoryId"
                  item-text="categoryName"
                  @change="onChangeArea($event)"
                  v-validate="'required'"
                  :data-vv-as="$t('Khu nuôi')"
                  :error-messages="errors.first('areaId')"
              />
            </v-flex>
            <v-flex xs12>
              <v-autocomplete
                  :items="lstCropActive"
                  label="Tên vụ nuôi"
                  v-model="cropId"
                  name="cropId"
                  item-value="cropId"
                  item-text="name"
                  v-validate="'required'"
                  :data-vv-as="$t('Tên vụ nuôi')"
                  :error-messages="errors.first('cropId')"
              />
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">
            <v-icon dark left>save</v-icon>
            {{ $t("Tạo phiếu") }}
          </v-btn>
          <v-btn color="error" @click="close">
            <v-icon dark left>cancel</v-icon>
            {{ $t("lang.common.cancel") }}
          </v-btn>
        </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import axios from "axios";
import moment from "moment";
import {areaContants, requestConstants, roleConstants} from "@/constants";
import {message} from "@/shared/message";
import IDatepicker from "@/components/form/DatePicker";

export default {
  name: "export_request",
  components: {IDatepicker, CSearchForm},
  data: () => {
    return {
      formName: "Danh sách đề nghị xuất kho theo quy trình",
      roleGroup: 0,
      reload: 0,
      dialog: false,
      approveDialog: false,
      lstArea: [],
      lstCrop: [],
      lstCropActive: [],
      warehouses: [],
      lstRequestOrder: [],
      requestStatus: [],
      requestStatusSummaryList: [],
      requestStatusSummary:'',
      materialTypeAllyId: null,
      searchUrl: "",
    ///exportRequest/search
      areaId: '',
      cropId: '',
      requestDate: '',
      activeArea: '',
      validFormCreateRequest: true,
      lastSearchValues: {},
      hiddenFields: {
        exportType: 1,
        areaId: '',
      },
      itemCreate: {
        reqOrdId: '',
        requestOrderNumber: '',
      },
      active_tab: 0,
      tabs: [
        {id: 1, name: 'Xuất sản xuất theo QTN'},
        {id: 2, name: 'Xuất sản xuất không theo quy trình'},
        // {id: 3, name: 'Xuất bán'},
        // {id: 4, name: 'Xuất hủy'}
      ],
      lstMaterialTypeAlly:[],
      fields: [
        {
            value: "index",
            text: "lang.common.index",
            width: "5%",
            sortable: false,
            headerStyle: "text-align:center",
        },
        // {
        //   value: "checkbox",
        //   text: "lang.common.index",
        //   sortable: false,
        //   headerStyle: "text-align:center",
        // },
        {
          value: "requestNumber",
          text: "Số đề nghị",
          search: true,
          headerStyle: "text-align:center",
        },
        {
          value: "exportDate",
          text: "Ngày xuất kho yêu cầu",
          headerStyle: "text-align:center",
          dateFormat: 'dd/MM/yyyy',
          search: true,
          type: "datepicker",
        },
        {
          value: "areaId",
          text: "Khu nuôi",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "areaId",
          items: [],
          itemText: "categoryName",
          itemValue: "categoryId",
        },
        {
          value: "cropId",
          text: "Tên vụ nuôi",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "cropId",
          items: [],
          itemText: "name",
          itemValue: "cropId",
        },
        {
          value: "procedureId",
          text: "Quy trình nuôi",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "procedureId",
          items: [],
          itemText: "code",
          itemValue: "procedureId",
        },
        {
          value: "status",
          text: "lang.user.status",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "status",
          items: [],
          itemText: "text",
          itemValue: "value",
        },
        {
          value: "action",
          width: "5%",
          text: "lang.common.actions",
          compound: true,
          headerStyle: "text-align:center",
        },
      ],
      buttons: [
      ],
    };
  },

  created() {
    let queryParam = this.$route.query;
    let searchQT = queryParam.searchQT;

    if(searchQT !=undefined){
      try{
        this.lastSearchValues = JSON.parse(searchQT);
      } catch (e){

      }
    }
    let tabId = this.tabs[0].id;
    let activeTab = queryParam.activeTab;
    if(activeTab != undefined){
      tabId = activeTab;
      this.active_tab = activeTab -1;
    }
    this.searchUrl = "/exportRequest/searchList?exportType="+tabId+"&";

    // 4: kỹ sư trưởng;  25: kỹ sư viên
    const role = parseInt(this.$store.state.auth.user.role);
    if (role == 4 || role == 25 || role == 3) {
      this.roleGroup = 1;
    } else if (role == 2) {
      this.roleGroup = 2;
    }

    if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR){
     this.buttons = [{
        event: "openApproveDialog",
        color: "green",
        icon: "library_add_check",
        text: "Phê duyệt"
      }]
    } else if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER){
      this.buttons = [{
        event: "onConfirmDialog",
        color: "purple",
        icon: "library_add_check",
        text: "Xác nhận"
      },]
    } else if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER){
      this.buttons = [{
        event: "onConfirmDialog",
        color: "purple",
        icon: "library_add_check",
        text: "Xem phiếu"
      },]
    }

    this.setRequestStatus();

    this.setRequestStatusSummaryList();

    // khu nuôi
    this.getPondArea();
    this.getWarehouse();
    this.getCropList();
    this.getProcedureWh();
    this.getMaterialTypeAlly();
  },
  computed: {
    roleBgd() {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR) {
        return true;
      } else {
        return false;
      }
    },
    roleWh() {
      // return true;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER) {
        return true;
      } else {
        return false;
      }
    },
    roleChiefEngineer() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER) {
        return true;
      } else {
        return false;
      }
    },

    getFormName(){
        if(this.active_tab==0){
          return "Danh sách đề nghị xuất kho theo quy trình"
        } else if (this.active_tab==1){
          return "Danh sách đề nghị xuất kho không theo quy trình"
        } else if (this.active_tab==2){
          return "Danh sách xuất bán"
        } else if (this.active_tab==3){
          return "Danh sách xuất hủy"
        }
      },

    showCreate() {
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
        || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ENGINEER
        || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ADMIN
        || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.ACCOUNTANT && this.active_tab == 1) {
        return true;
      } else {
        return false;
      }
    },
  },


  methods: {
    setLastSearchValues: function (values) {
      //this.lastSearchValues = Object.assign(this.lastSearchValues, {"searchQT":JSON.stringify(values)});
      this.lastSearchValues = Object.assign(this.lastSearchValues, values);
    },
    createParamLastSearch: function (values) {
      return {"searchQT":JSON.stringify(values), "activeTab": this.active_tab + 1};
    },
    openCreateDialog: function () {
      this.dialog = true;
    },
    viewItem: function (item) {
      if(item.exportType == 2) {
          //this.$router.push({path: '/exportRequest/NotProcessView/' + item.exportId});
          this.$router.push({ path:  '/exportRequest/NotProcessView/' + item.exportId, query: this.createParamLastSearch(this.lastSearchValues) });
      } else {
          if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER) {

            //this.$router.push({path: '/exportRequest/wkView/' + item.exportId});
            this.$router.push({ path:  '/exportRequest/wkView/' + item.exportId, query: this.createParamLastSearch(this.lastSearchValues) });

          } else {
            //this.$router.push({path: '/exportRequest/view/' + item.exportId});
            this.$router.push({ path:  '/exportRequest/view/' + item.exportId, query: this.createParamLastSearch(this.lastSearchValues) });
          }
      }
      
    },
    close() {
      this.dialog = false;
    },
    onApprove: function () {
      if(this.isNullOrEmpty(this.areaId)){
        message.error("Chưa chọn khu nuôi")
        return
      }
      if(this.isNullOrEmpty(this.requestDate)){
        message.error("Chưa chọn ngày xuất")
        return
      }
      if(this.isNullOrEmpty(this.requestStatusSummary)){
        message.error("Chưa chọn Trạng thái")
        return
      }
      if (this.active_tab == 1) {
        this.$router.push({path: '/exportRequest/approveNotProcess/' + this.areaId + "/requestDate/"
              + this.requestDate+ "/status/" + this.requestStatusSummary+ "/materialTypeAllyId/"+ this.materialTypeAllyId});
      } else {

        this.$router.push({path: '/exportRequest/approve/' + this.areaId + "/requestDate/"+ this.requestDate
              + "/status/" + this.requestStatusSummary+ "/materialTypeAllyId/"+ this.materialTypeAllyId});
      }
    },
    onConfirm: function () {
      if(this.isNullOrEmpty(this.areaId)){
        message.error("Chưa chọn khu nuôi")
        return
      }
      if(this.isNullOrEmpty(this.requestDate)){
        message.error("Chưa chọn ngày xuất")
        return
      }
      if(this.isNullOrEmpty(this.requestStatusSummary)){
        message.error("Chưa chọn Trạng thái")
        return
      }
      if (this.active_tab == 1) {
        this.$router.push({path: '/exportRequest/confirmNotProcess/' + this.areaId + "/requestDate/"+ this.requestDate
              + "/status/" + this.requestStatusSummary + "/materialTypeAllyId/"+ this.materialTypeAllyId});
      } else {
        this.$router.push({path: '/exportRequest/confirm/' + this.areaId + "/requestDate/"+ this.requestDate
              + "/status/" + this.requestStatusSummary + "/materialTypeAllyId/"+ this.materialTypeAllyId});
      }
    },
    onConfirmWh: function () {
      if(this.isNullOrEmpty(this.areaId)){
        message.error("Chưa chọn khu nuôi")
        return
      }
      if(this.isNullOrEmpty(this.requestDate)){
        message.error("Chưa chọn ngày xuất")
        return
      }
      if(this.isNullOrEmpty(this.requestStatusSummary)){
        message.error("Chưa chọn Trạng thái")
        return
      }
      if (this.active_tab == 1) {
        this.$router.push({path: '/exportRequest/confirmNotProcess/' + this.areaId + "/requestDate/"+ this.requestDate+ "/status/" + this.requestStatusSummary});
      } else {
        this.$router.push({path: '/exportRequest/confirm/' + this.areaId + "/requestDate/"+ this.requestDate
              + "/status/" + this.requestStatusSummary + "/materialTypeAllyId/"+ this.materialTypeAllyId});
      }
    },
    closeApproveDialog(){
      this.approveDialog = false;
    },
    createNotByProcess() {
      this.$router.push({path: '/exportRequest/notProcessCreate'});
    },
    save() {
      // console.log(this.active_tab);
      this.$validator.validate().then((valid) => {
          if (!valid) {
              message.error(this.$t("lang.common.validate_fail"));
              return;
          }
          this.dialog = false;
          if (this.active_tab == 1) {
              this.$router.push({path: '/exportRequest/notProcessCreate/' + this.cropId + '/type/' + (parseInt(this.active_tab) + 1)});
          } else {
              this.$router.push({path: '/exportRequest/create/' + this.cropId + '/type/' + (parseInt(this.active_tab) + 1)});
          }
      });
    },
    getPondArea() {
      axios.post(
          process.env.VUE_APP_API_URL +
          "/category/myArea"
      )
          .then((data) => {
            if (data.length > 0) {
              this.lstArea = data;
              let itemFields = this.fields.filter(function (e) {
                return e.name == "areaId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
          });
    },
    getWarehouse() {
      axios.post(
          process.env.VUE_APP_API_URL +
          "/category/listByType?type=WAREHOUSE"
      )
          .then((data) => {
            if (data.length > 0) {
              this.warehouses = data;
              let itemFields = this.fields.filter(function (e) {
                return e.name == "warehouseId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
          });
    },
    dateFormat(date) {
      return moment(String(date)).format('DD-MM-YYYY');
    },
    onChangeArea(even) {
      this.getCropActive();
    },
    getCropList() {
      const search = {};
      axios.post(
          process.env.VUE_APP_API_URL + "/crop/search?sortField=code&pageSize=-1&page=-1&orderBy=desc", search
      )
          .then(
              (data) => {
                if (data.items) {
                  this.lstCrop = data.items;
                  let itemFields = this.fields.filter(function (e) {
                    return e.name == "cropId";
                  });
                  if (itemFields != undefined && itemFields.length > 0) {
                    itemFields[0].items = data.items;
                  }
                }
              }
          );
    },
    getCropActive() {
      //test
      //const search = {}
      //that
      const search = {status: 1};
      if (this.areaId > 0) search.pondAreaId = this.areaId;
      axios.post(
          process.env.VUE_APP_API_URL + "/crop/search?sortField=code&pageSize=-1&page=-1&orderBy=desc", search
      )
          .then(
              (data) => {
                if (data.items) {
                  this.lstCropActive = data.items;
                }
              }
          );
    },
    getProcedureWh(params = {}) {
      const search = {};
      axios.post(
          process.env.VUE_APP_API_URL + "/procedureWh/search?pageSize=-1&page=-1&orderBy=asc",
          search
      )
          .then(
              (data) => {
                if (data.items) {
                  this.procedureWh = data.items;
                  let itemFields = this.fields.filter(function (e) {
                    return e.name == "procedureId";
                  });
                  if (itemFields != undefined && itemFields.length > 0) {
                    itemFields[0].items = data.items;
                  }
                }
              }
          );
    },
    onSelectArea(areaId = '') {
      this.activeArea = areaId;
      this.areaId = areaId;
      const hiddenFields = Object.assign(this.hiddenFields, {areaId: areaId});
      this.hiddenFields = hiddenFields;
      this.getCropList();
    },
    formSelectChange(name, value) {
      if (name == 'areaId') {
        this.activeArea = value;
        this.areaId = value;
      }
    },
    selectTab(id) {
      //this.hiddenFields = Object.assign(this.hiddenFields, {exportType: id});
      this.lastSearchValues = {};
      //this.reload = Math.random();
      this.searchUrl = "/exportRequest/searchList?exportType="+id+"&";

    },
    openApproveDialog(){
      this.approveDialog = true;
    },
    onConfirmDialog() {
      this.approveDialog = true;
    },
    onCancel() {
      this.reload = Math.random();
    },
    setRequestStatus() {
      let status = requestConstants.requestExportStatus;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER) {
        status = status.filter(function (e) {
          return e.value >= 4;
        });
      } else if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR) {
        status = status.filter(function (e) {
          return e.value >= 2;
        });
      }

      this.requestStatus = status;
      let itemFields = this.fields.filter(function (e) {
        return e.name == "status";
      });
      if (itemFields != undefined && itemFields.length > 0) {
        itemFields[0].items = status;
      }
    },
    setRequestStatusSummaryList () {
      let status = requestConstants.requestExportStatus;
      if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER) {
        status = status.filter(function (e) {
          return e.value != 3;
        });
      } else if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR) {
        status = status.filter(function (e) {
          return (e.value >= 2 && e.value !=3);
        });
      } else if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.WAREHOUSE_KEEPER) {
        status = status.filter(function (e) {
          return e.value >= 4;
        });
      }

      this.requestStatusSummaryList = status;
    },
    getMaterialTypeAlly() {
      axios.post(
          process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE_ALLY"
      ).then(
          (data) => {
            if (data.length > 0) {
              this.lstMaterialTypeAlly = data;
            }
          }
      );
    },
  },
  destroyed() {
  },
};
</script>
